<template lang="html">
  <div class="stones-form__step-content">
    <FormData
      type-form="stone"
      @submitForm="submitForm"
      @cancelSubmit="cancelSubmit"
    />
  </div>
</template>

<script>
import FormData from '@/components/Form/FormData.vue';

export default {
  name: 'StonesFormStep1',
  components: {
    FormData,
  },
  methods: {
    submitForm() {
      // console.log(e);
      this.$store.commit('stones/setFormCurrentStep', 2);
    },
    cancelSubmit() {
      this.$store.commit('stones/setFormStepsIsShow', false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'styles';
</style>
